













import { Component, Prop } from "vue-property-decorator";
import { DialogComponent } from "vue-modal-dialogs";

import BulkShipmentDestinationEditForm from "./BulkShipmentDestinationEditForm.vue";

import BulkShipment from "../bulk-shipment.model";
import DistributionCenter from "../distribution-center.model";

@Component({
  components: { BulkShipmentDestinationEditForm },
})
export default class BulkShipmentDestinationEditDialog extends DialogComponent<boolean> {
  @Prop({ required: true })
  public readonly shipment!: BulkShipment;

  @Prop({ required: true })
  public readonly distributionCenters!: DistributionCenter[];

  public closeDialog(): void {
    // eslint-disable-next-line vue/custom-event-name-casing
    this.$emit("vue-modal-dialogs:close", false);
  }

  public onSaved(): void {
    // eslint-disable-next-line vue/custom-event-name-casing
    this.$emit("vue-modal-dialogs:close", true);
  }
}
